<template>
  <div v-if="benefitDetailData.iframeUrl">
    <iframe class="iframe" :src="getBenefitIframeUrl(benefitDetailData)" frameborder="0" />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      benefitId: parseInt(this.$route.query.benefitId, 10),
      info: null,
    };
  },
  methods: {
    getBenefitIframeUrl(benefit) {
      return `${benefit.iframeUrl}`;
    },
  },
  computed: {
    benefitDetailData() {
      return this.$store.getters.benefitsDetail(this.benefitId);
    },
  },
};
</script>

<style lang="sass" scoped>
.iframe
  width: 100%
  height: 500px
  object-fit: fill
  object-position: center center
</style>
